import { useAppSelector } from 'app/hooks';
import { selectEditModeData } from 'features/common/editModeSlice';
import { FaSyncAlt } from 'react-icons/fa';
import './style.scss';

interface FeatureTitleBarProps {
  title: string;
}

function FeatureTitleBar({ title }: FeatureTitleBarProps) {
  const deliveryId = useAppSelector(selectEditModeData)?.deliveryId;

  return (
    <div className="page-head-title bg-violet py-2 px-3 d-inline-block fw-bold mb-3">
      <div className="d-flex align-items-center">
        <div>{title}</div>
        {deliveryId && (
          <div className="badge-reedit">
            <div className="badge-reedit-icon">
              <FaSyncAlt size={9} />
            </div>
            <span className="ms-2">再編集モード / 配信No: {deliveryId}</span>
          </div>
        )}
      </div>
    </div>
  );
}

export default FeatureTitleBar;
